<template>
  <div id= "sitemap">
    <ul>
      <li v-for="(page,index) in pageList" :key="'sitemap-' + index" :value="page.id"
          v-bind:style="{left: (-20 * index) + 'px'}"
          v-bind:class="{non_active: (page.key !== pageKey)}">
        <div class="pageTitle">{{page.title}}</div>
        <div v-if="index !== (pageList.length - 1)" class="arrow"></div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'addNewUserModal',
  components: {
  },
  props: {
    pageKey: String,
    pageList: Array
  },
  data () {
    return {
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/common/SiteMap.vue